import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { dataLoading } from "../../../assets/assets";
import httpApiCall from "../../../service/api.service";
import { getStorageValue } from "../../../service/shared.service";
import { formatDate, formatDate2 } from "../../../utils/DateFormat";
import Table from "../../elements/tableComponent";

const Logs = () => {
  const [shimmer, setShimmer] = useState(false);
  const columns = [
    { title: "S.NO", dataKey: "sno" },
    { title: "Email", dataKey: "email" },
    { title: "Url", dataKey: "url" },
    { title: "Referral Date", dataKey: "referCode" },
    { title: "Status", dataKey: "status" },
  ];
  const filter = [
    {
      id: 0,
      name: "All",
    },
    {
      id: 1,
      name: "Registered",
    },
    {
      id: 2,
      name: "Not Registered",
    },
  ];
  const [Tab, setTab] = useState(1);
  const [data, setData] = useState<any>([]);
  const partnerData = getStorageValue("partnerData");

  useEffect(() => {
    getLogList(0);
  }, [Tab]);

  const getLogList = async (e:any) => {
    setShimmer(true)
    const body = {
      access_token: partnerData && partnerData["access_token"],
      filter: e,
      domain_type: Tab,
      limit: 10,
      offset: 0,
    };
    await httpApiCall({
      api: "get_shared_partner_websites",
      type: "POST",
      body,
    }).then(async (data) => {
      setShimmer(false);
      setData(data);
    });
  };
  const rows =
    data && data.referrals
      ? data.referrals.map((row: any, index: number) => [
          index + 1,
          row.refer_email,
          row.web_url,
          formatDate2(row.date_added),
          row.status ? "Registered" : "Not Registered",
        ])
      : [];
  const tabChange = (e: any) => {
    setTab(e);
  };
  return (
    <div className="logs-list">
      <div className="logs-list-header">
        <ul>
          <li
            className={`${Tab == 1 ? "active" : ""}`}
            onClick={() => tabChange(1)}
          >
            Partner To Business
          </li>
          <li
            className={`${Tab == 2 ? "active" : ""}`}
            onClick={() => tabChange(2)}
          >
            Partner To Partner
          </li>
        </ul>
      </div>
      <div>
        <Form.Select className="w-25 mt-3" onClick={(event:any) => getLogList(event.target.value)}>
          {filter.map((item: any, i: any) => (
            <option key={i} value={item.id} >
              {item.name}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="mt-4">
      {shimmer && (
          <div className="no_data_v2 text-center">
            <img src={dataLoading} alt="" />
          </div>
        )}
        {!shimmer &&<Table callFunction={() => console.log('call from logs')} data={rows} columns={columns}></Table>}
      </div>
    </div>
  );
};

export default Logs;
